

import { list44000Sprint07 } from '../ActivityLists/AL44000Sprint07'
import { list44000Sprint08 } from '../ActivityLists/AL44000Sprint08'

import { productPresentation, xyz_8_1of1_PAaA, xyz_8_ClassProductPresentations } from './SL00000Sprint00TTR'

// Software Engineering (SE) sprint 8 global values.
const sprint = 8
const activityList = () => { return list44000Sprint08(sprint) }
const activityListPrevious = () => { return list44000Sprint07(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }





const se_8_1of1 = () => { return xyz_8_ClassProductPresentations(xyz_8_1of1_PAaA, null, sprintAndActivityLists, productPresentation) }

export const se_8_slidedeckTTR = [ se_8_1of1 ]